import React from "react";
import TrainingExecution from "./trainingExecution";
import TrainingSelection from "./trainingSelection";
import useMyTraining from "./useMyTraining";
import ParticipantsDialog from "./participantsDialog";
import StatsPage from "./statsPage";

const MyTraining = () => {

  const {
    isLoading,
    activeList,
    finishedList,
    canViewStats,
    participants,
    specificTrainingData,
    activityData,
    trainingStats,
    participantStats,
    state,
    handlers,
  } = useMyTraining();

  return (
    <>
      {
        state.participantsDialogIsOpen &&
        <ParticipantsDialog
          open={state.participantsDialogIsOpen}
          data={participants}
          handleClose={handlers.handleCloseParticipantsDialog}
        />
      }
      {
        !state.selectedTrainingId && !state.statsPageIsOpen &&
        <TrainingSelection
          isLoading={isLoading}
          activeList={activeList}
          finishedList={finishedList}
          canViewStats={canViewStats}
          handleSelect={handlers.handleOpenTrainingExecution}
          handleShowParticipants={handlers.handleOpenParticipantsDialog}
          handleDownloadCertificates={handlers.handleDownloadCertificates}
          handleOpenStatsPage={handlers.handleOpenStatsPage}
        />
      }
      {
        state.statsPageIsOpen &&
        <StatsPage
          isLoading={isLoading}
          trainingStats={trainingStats}
          participantStats={participantStats}
          handleGoBack={handlers.handleCloseStatsPage}
        />
      }
      {
        Boolean(state.selectedTrainingId) &&
        <TrainingExecution
          isLoading={isLoading}
          trainingData={specificTrainingData}
          activityData={activityData}
          handleShowParticipants={handlers.handleOpenParticipantsDialog}
          handleClose={handlers.handleCloseTrainingExecution}
        />
      }
    </>
  )
}

export default MyTraining;